import { useMutation } from "@tanstack/react-query";
import { resendVerification, type ResendVerificationResponse } from "../api/auth.api";
import { ApiError } from "@/lib/api/client";

export function useResendVerification() {
  return useMutation<ResendVerificationResponse, ApiError, string>({
    mutationFn: resendVerification,
  });
}
